// extracted by mini-css-extract-plugin
module.exports = {"sidecar":"_e004868","sidecarCard":"_c9ed8fc","sidecarButtonsRoot":"_5d741f8","sidecarButtonRegister":"_5ab9ee5","sidecarInfoContainer":"_c027269","valueRed":"_a994082"};